import React, { Component } from 'react';
import Link from '../components/link';

import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import {
    Container,
    Row,
    Col,
    Input,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
    CarouselCaption,
    UncontrolledDropdown,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter, Button
} from 'reactstrap';

import ok from '../assets/svg/ok.svg';


import moment from 'moment';

import { Player, Controls } from "@lottiefiles/react-lottie-player";

import no_content from '../assets/images/no_content.png';

import arrow_left from '../assets/arrow-left.svg';
import list_1 from '../assets/list-1.svg';
import list_2 from '../assets/list-2.svg';
import arrow_right from '../assets/arrow-right.svg';
import weather from '../assets/weather.svg';
import searchIcon from '../assets/search-icon.svg';
import cartIcon from '../assets/cart-icon.svg';
import app from '../assets/app.png';
import b1 from '../assets/b1.png';
import throphy1 from '../assets/images/throphy1.png'
import throphy3 from '../assets/images/throphy2.png'
import throphy2 from '../assets/images/throphy3.png'
import shape1 from '../assets/svg/shape-1.svg';
import shape2 from '../assets/svg/shape-2.svg';

import details_naslovna from '../assets/details-naslovna.jpg';

import ReactPaginate from 'react-paginate';
import RightSidebar from '../components/rightSidebar';
import { API_ENDPOINT } from '../constants';

import { Redirect } from 'react-router-dom';
import xIcon from '../assets/svg/x-icon.svg';
import docSvg from '../assets/svg/doc_svg.svg';


var striptags = require('striptags');

class ShopPage extends Component {
    constructor(props) {
        super(props);
        this.updateStateFromSearch = this.updateStateFromSearch.bind(this);
        this.updateParam = this.updateParam.bind(this);
        this.get = this.get.bind(this);

        this.state = {
            page: 0,
            view: 0,
            projects: [],
            ...props.initialData,
            projectName: '',
        };

        this.timerRef = null;
    }

    updateStateFromSearch(callback) {
        let broken = this.props[0].location.search.split('?').pop().split('&');
        let params = { page: 0 };
        for (let i = 0; i < broken.length; i++) {
            if (broken[i].indexOf('=') !== -1) {
                params[broken[i].split('=')[0]] = broken[i].split('=')[1];
            }
        }
        let setObj = {
            category: null,
            tag: null,
            items: []
        }
        if (!params.pretraga && this.state.search) {
            setObj.search = '';
        }
        this.setState(setObj, () => {
            this.setState(params, callback);

        })

    }


    updateParam(name, value) {

        let broken = this.props[0].location.search.split('?').pop().split('&');
        let params = {};
        for (let i = 0; i < broken.length; i++) {
            if (broken[i].indexOf('=') !== -1) {
                params[broken[i].split('=')[0]] = broken[i].split('=')[1];
            }
        }


        params[name] = value;

        let paramsArr = [];
        for (var key in params) {
            if (params.hasOwnProperty(key) && params[key]) {

                paramsArr.push(key + "=" + params[key]);
            }
        }




        let search = '?' + paramsArr.join('&');


        this.props[0].history.push(this.props[0].location.pathname + search);
        ////console.log(search);
    }

    backButton() {
        this.updateParams(['pretraga', 'page'], ['', null])
        this.setState({ projectName: '', projectId: '' })
    }
    updateParams(names, values) {

        let broken = this.props[0].location.search.split('?').pop().split('&');
        let params = {};
        for (let i = 0; i < broken.length; i++) {
            if (broken[i].indexOf('=') !== -1) {
                params[broken[i].split('=')[0]] = broken[i].split('=')[1];
            }
        }


        for (let i = 0; i < names.length; i++) {
            const name = names[i];
            const value = values[i];

            if (value === null) {
                delete params[name];
            } else {
                params[name] = value;
            }
        }


        let paramsArr = [];
        for (let key in params) {
            if (params.hasOwnProperty(key) && params[key]) {
                paramsArr.push(`${key}=${params[key]}`);
            }
        }

        let search = '?' + paramsArr.join('&');

        this.props[0].history.push(this.props[0].location.pathname + search);
    }


    componentDidUpdate(prevProps, prevState) {
        const params = this.getParams();
        const prevParams = this.getPrevParams(prevProps);

        // Ako se promeni 'table' parametar u URL-u
        if (params.table !== prevParams.table && params.table) {
            const project = this.state.projects.find(p => p.name === params.table);
            if (project && project._id !== this.state.projectId) {
                this.setState({
                    projectId: project._id,
                    projectName: project.label,
                    search: '' // Resetuj pretragu
                }, () => {
                    this.get();
                });
            }
        }

        if (prevProps[0].location.search !== this.props[0].location.search) {
            this.updateStateFromSearch(() => {
                this.get();
            });
        }

        if (prevProps[0].location.pathname !== this.props[0].location.pathname) {
            this.get();
            this.resetSerach();
        }
    }

    getPrevParams = (prevProps) => {
        let broken = prevProps[0].location.search.split('?').pop().split('&');
        let params = {};
        for (let i = 0; i < broken.length; i++) {
            if (broken[i].indexOf('=') !== -1) {
                params[broken[i].split('=')[0]] = broken[i].split('=')[1];
            }
        }
        return params;
    }

    backButton() {
        // Ukloni 'table' parametar i vrati se na izbor projekata
        this.updateParams(['pretraga', 'page', 'table'], ['', null, null]);
        this.setState({ projectName: '', projectId: '' });
    }


    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        // Prvo učitaj projects
        Promise.all(
            this.props.loadData.map(fn =>
                fn(window.fetch, this.props.lang, this.props[0].match)
                    .then(data => this.setState({ ...data }))
            )
        ).then(() => {
            // Proveri URL parametar 'table'
            const params = this.getParams();
            const tableParam = params.table;

            if (tableParam && this.state.projects.length > 0) {
                // Pronađi projekat po 'table' parametru
                const project = this.state.projects.find(p => p.name === tableParam);
                if (project) {
                    this.setState({
                        projectId: project._id,
                        projectName: project.label
                    }, () => {
                        this.get();
                    });
                    return;
                }
            }

            // Ako nema 'table' parametra, ali ima samo 1 projekat
            if (this.state.projects.length === 1) {
                this.setState({
                    projectId: this.state.projects[0]._id,
                    projectName: this.state.projects[0].label
                }, () => {
                    this.get();
                });
            }
        });

        this.updateStateFromSearch(this.get);
    }

    resetSerach = () => {
        this.setState({ search: null }, () => {
            this.updateParam('pretraga', null);
        });
    }
    getParams = () => {

        let broken = this.props[0].location.search.split('?').pop().split('&');
        let params = {};
        for (let i = 0; i < broken.length; i++) {
            if (broken[i].indexOf('=') !== -1) {
                params[broken[i].split('=')[0]] = broken[i].split('=')[1];
            }
        }

        return params;

    }
    get() {
        if (this.state.projectId) {
            const searchParams = new URLSearchParams(this.getParams());

            if (searchParams && searchParams.get('pretraga') !== null) {
                searchParams.set('search', searchParams.get('pretraga'));
            }

            fetch(`${API_ENDPOINT}/data/dynamic-tables/project/${this.state.projectId}?${searchParams.toString()}`, {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
            }).then(res => res.json()).then((result) => {
                this.setState({
                    items: result.data,
                    total: result.total,
                    show: result.show,
                })
            })

        }
    }

    searchShop = () => {
        let search = this.state.search;
        this.updateParams(['pretraga', 'page'], [search, null])
    }

    selectProject = (project) => {
        this.setState({
            projectId: project._id,
            projectName: project.label
        }, () => {
            this.updateParam('table', project.name);
            this.get();
        });
    }

    returnClassname = (index) => {
        const params = new URLSearchParams(this.props[0].location.search);
        const pretraga = params.get('pretraga');
        if (pretraga && pretraga.trim() !== '') return '';

        if (this.state.page === 1) {
            return index === 0 ? 'golden'
                : index === 1 ? 'dark-dark-blue'
                    : index === 2 ? 'light-light-blue'
                        : '';
        }

        // when page is falsy (0, undefined, null) and there is no search
        if (!this.state.page && (!pretraga || pretraga === '')) {
            return index === 0 ? 'golden'
                : index === 1 ? 'dark-dark-blue'
                    : index === 2 ? 'light-light-blue'
                        : '';
        }

        return '';
    }

    returnFirstColumn = (index) => {
        const cls = (this.returnClassname(index) || '').trim();

        if (cls === '') {
            // ensure page is a number or fallback to 0
            const pageNum = Number(this.state.page) || 0;
            return pageNum * 10 + (index + 1);
        }

        if (cls === 'golden') {
            return <img src={throphy1} alt="throphy" />
        } else if (cls === 'dark-dark-blue') {
            return <img src={throphy2} alt="throphy" />
        } else if (cls === 'light-light-blue') {
            return <img src={throphy3} alt="throphy" />
        }

        return '';
    }

    render() {
        const params = this.getParams()
        let pagination = false;

        let otherPages = false;
        const itemPerPage = 10;

        if (this.state.total / itemPerPage) {
            otherPages = true;
        }
        if (otherPages) {
            pagination = true;
        }


        return (
            <div>
                {
                    typeof localStorage !== 'undefined' && !localStorage.token ? <Redirect to='/prijava' /> : null
                }
                <img src={shape1} className="shape-1" />
                <img src={shape2} className="shape-2" />
                <section id="content">
                    <Container>
                        <Row>
                            <Col lg="9" className="nop">
                                <div className="content l-0 r-fix pd0">
                                    <div className="content-container">
                                        {
                                            (!this.state.projects.length || (this.state.projectId && !this.state.items)) ?
                                                <>
                                                    <div className="no-content" >
                                                        <Player
                                                            autoplay={true}
                                                            loop={true}
                                                            src="/lf30_editor_w4hitwma.json"
                                                            style={{ width: "60%" }}
                                                        ></Player>
                                                        <p>Stranica u izradi...</p>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    {!this.state.projectName ? <h5 className='table-title'>Izaberite projekat</h5> :
                                                        <div className='table-title-wrapper '><button className='back-button' onClick={() => { this.backButton() }}><Isvg src={arrow_left} /></button> <h5 className="table-title">{this.state.projectName}</h5> </div>}
                                                    {!this.state.projectId && this.state.projects.length ?
                                                        <>
                                                            <div className='projects-list'>
                                                                {this.state.projects.map((project) => {
                                                                    return <div className='project-row' key={project._id} onClick={() => this.selectProject(project)}>
                                                                        {project.label}
                                                                    </div>
                                                                })}
                                                            </div>
                                                        </> : <>
                                                            <div className='web-shop-search-field-wrap right-sided mb-4'>
                                                                <Input
                                                                    type='text'
                                                                    placeholder='Pretraga...'
                                                                    value={this.state.search}
                                                                    onChange={(e) => {
                                                                        if (this.state.search !== e.target.value)
                                                                            this.setState({ search: e.target.value })
                                                                    }}
                                                                    onKeyUp={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            this.searchShop()
                                                                        }
                                                                    }}

                                                                />
                                                                <div className='serach-button' onClick={() => this.searchShop()}>
                                                                    <Isvg src={searchIcon} />
                                                                </div>
                                                            </div>

                                                            {/* Tabela 1 - Mastercard */}
                                                            {this.state.show && this.state.items && (
                                                                <div className="page-table-wrapper mini mb-4">
                                                                    {/* <h5 className='table-title text-center pb-2'>Leaderboard Mastercard kampanje</h5> */}
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope='col'></th>
                                                                                {Object.entries(this.state.show).map(([key, value]) => (
                                                                                    <th key={key} scope="col">{value}</th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.items.map((item, index) => (
                                                                                <tr key={item._id} className={`${this.returnClassname(index)}`}>
                                                                                    <td className={'text-center'}>{this.returnFirstColumn(index)}</td>
                                                                                    {Object.entries(this.state.show).map(([key]) => (
                                                                                        <td key={key}>{item[key]}</td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}

                                                            {/* Tabela 2 - Ljetovanje */}
                                                            {this.state.showLeaderboards && this.state.leaderboards && (
                                                                <div className="page-table-wrapper mini">
                                                                    {/* <h5 className='table-title text-center pb-2'>Leaderboard kartičnih plaćanja - Osvoji ljetovanje</h5> */}
                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope='col'></th>
                                                                                {Object.entries(this.state.showLeaderboards).map(([key, value]) => (
                                                                                    <th key={key} scope="col">{value}</th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {this.state.leaderboards.map((item, index) => (
                                                                                <tr key={item._id} className={`${this.returnClassname(index)}`}>
                                                                                    <td className={'text-center'}>{this.returnFirstColumn(index)}</td>
                                                                                    {Object.entries(this.state.showLeaderboards).map(([key]) => (
                                                                                        <td key={key}>{item[key]}</td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            )}

                                                            {
                                                                pagination ?
                                                                    <Row>
                                                                        <Col lg="12">
                                                                            <ReactPaginate
                                                                                previousLabel={''.translate(this.props.lang)}
                                                                                nextLabel={''.translate(this.props.lang)}
                                                                                breakLabel={'...'}
                                                                                breakClassName={'break-me'}
                                                                                pageCount={this.state.total / itemPerPage}
                                                                                marginPagesDisplayed={1}
                                                                                pageRangeDisplayed={2}
                                                                                onPageChange={(page) => { this.updateParam('page', page.selected); window.scrollTo(0, 0); }}
                                                                                containerClassName={'pagination'}
                                                                                subContainerClassName={'pages pagination'}
                                                                                activeClassName={'active'}
                                                                                hrefBuilder={(page) => { return `?page=${page}` }}
                                                                                forcePage={Number(this.state.page)}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    :
                                                                    null
                                                            }
                                                        </>}
                                                </>
                                        }
                                    </div>
                                </div>

                            </Col>
                            <Col lg="3" className="nop">
                                {
                                    this.state.home && this.state.home.statistics ?
                                        <RightSidebar
                                            totalVehicles={this.state.home.statistics.totalVehicles}
                                            newMembers={this.state.home.statistics.newMembers}
                                            deliveryLines={this.state.home.statistics.deliveryLines}
                                            warehouses={this.state.home.statistics.warehouses}
                                            shops={this.state.home.statistics.shops}
                                            googlePlayLink={this.state.home.googlePlayLink}
                                            appStoreLink={this.state.home.appStoreLink}
                                            totalEmployess={this.state.home.statistics.totalEmployess}
                                        />
                                        :
                                        null
                                }
                            </Col>
                        </Row>
                    </Container>

                </section>

            </div >
        );
    }
}

export default Page(ShopPage);